import axios from "axios";
import { dropDown } from "./interfaces";

const apiURL = process.env.REACT_APP_API_URL;

export const getDepartmentDropdown = async (): Promise<dropDown[]> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get(`https://${apiURL}/Department/ForDropdown`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const data = response.data;

  const departmentDropdownData: dropDown[] = (data as dropDown[]).map(
    (item: any) => ({
      text: item.text,
      value: item.value,
    })
  );

  return departmentDropdownData;
};
